import React from "react";
import { fmtEuro } from "@/lib/format";
import { Delta } from "@/components/dashboard/Kpi";

export const REV_GROUPS = [
  { key: "villas", label: "Βίλες (διαμονή)", codes: ["4100"] },
  { key: "fb", label: "F&B — TRIBE POS & βίλες", codes: ["4200", "4210"] },
  { key: "spa", label: "Spa", codes: ["4600"] },
  { key: "tesla", label: "Tesla", codes: ["4500"] },
  { key: "transfers", label: "Transfers", codes: ["4700"] },
  { key: "events", label: "Εκδηλώσεις / Γάμοι", codes: ["4300"] },
  { key: "other", label: "Λοιπά", codes: ["4400"] },
];

export const groupRevenue = (rows, field) => {
  const by = Object.fromEntries((rows || []).map((r) => [r.code, Number(r[field]) || 0]));
  return Object.fromEntries(REV_GROUPS.map((g) => [g.key, g.codes.reduce((s, c) => s + (by[c] || 0), 0)]));
};

export const RevenueByDept = ({ cur, ly }) => {
  const m = groupRevenue(cur?.rows, "actual");
  const mLy = groupRevenue(ly?.rows, "actual");
  const y = groupRevenue(cur?.rows, "ytd_actual");
  const yLy = groupRevenue(ly?.rows, "ytd_actual");
  const sum = (o) => Object.values(o).reduce((s, v) => s + v, 0);
  const maxY = Math.max(...Object.values(y), 1);
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead>
          <tr className="text-left text-[10px] uppercase tracking-wider text-[#6F6A60] border-b border-[#E3DED4]">
            <th className="py-2 pr-3">Τμήμα</th><th className="py-2 px-2 text-right">Μήνας</th>
            <th className="py-2 px-2 text-right hidden sm:table-cell">Πέρσι</th><th className="py-2 px-2 text-right">Από αρχή έτους</th>
            <th className="py-2 pl-2 text-right">vs πέρσι</th>
          </tr>
        </thead>
        <tbody>
          {REV_GROUPS.filter((g) => y[g.key] || yLy[g.key] || m[g.key]).map((g) => (
            <tr key={g.key} className="border-b border-[#EFEBE3]" data-testid={`dash-rev-${g.key}`}>
              <td className="py-2 pr-3">
                <div className="font-medium text-[#45423C]">{g.label}</div>
                <div className="mt-1 h-1.5 rounded-full bg-[#F1EDE6] overflow-hidden"><div className="h-full bg-[#C86235] rounded-full" style={{ width: `${(y[g.key] / maxY) * 100}%` }} /></div>
              </td>
              <td className="py-2 px-2 text-right tabular">{fmtEuro(m[g.key])}</td>
              <td className="py-2 px-2 text-right tabular text-[#B9AE9A] hidden sm:table-cell">{fmtEuro(mLy[g.key])}</td>
              <td className="py-2 px-2 text-right tabular font-semibold">{fmtEuro(y[g.key])}</td>
              <td className="py-2 pl-2 text-right"><Delta cur={y[g.key]} ly={yLy[g.key]} /></td>
            </tr>
          ))}
          <tr className="font-semibold text-[#45423C]" data-testid="dash-rev-total">
            <td className="py-2.5 pr-3">Σύνολο</td>
            <td className="py-2.5 px-2 text-right tabular">{fmtEuro(sum(m))}</td>
            <td className="py-2.5 px-2 text-right tabular text-[#B9AE9A] hidden sm:table-cell">{fmtEuro(sum(mLy))}</td>
            <td className="py-2.5 px-2 text-right tabular">{fmtEuro(sum(y))}</td>
            <td className="py-2.5 pl-2 text-right"><Delta cur={sum(y)} ly={sum(yLy)} /></td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
